export const EndPoints = {
    acknowledge: 'OrderResult/Acknowledge',
    activateKitService: 'ActivateKit/ActivateKitAndCreateOrder',
    AssignPatientsToProject: 'Event/AssignPatientsToEvent/',
    browserDetails: 'BrowserDetails/GetBrowserDetails',
    BULK_UPLOAD_TEMPLATE_DOWNLOAD: 'BulkUpload/DownloadBulkUploadTemplate',
    BULK_UPLOAD_VALIDATE_PATIENT_INFO: 'BulkUpload/ValidateAndUploadBulkPatients/',
    CHANGE_PASSWORD: 'LabPortAuth/ChangePassword',
    CHECK_IF_KITID_EXISTS: 'CreateOrder/CheckIfKitIDExists/',
    CHECK_UNIQUE_ACCESSCODE: 'Event/CheckUniqueAccessCode',
    CHECKUNIQUE_BU_QUESTIONCODES: 'Question/CheckUniqueBUQuestionCode/',
    CHECKUNIQUE_BU_TESTCODES: 'Test/CheckUniqueBUTestCode/',
    GET_CONTACT_SUPPORT: 'Content/LabPort/ContactSupport',
    POST_CREATE_ANNOUNCEMENT: 'Announcement/CreateAnnouncement',
    CREATE_COMMERCIAL_ORDER: 'CreateOrder/CreateCommercialOrder',
    UPDATE_STANDING_ORDER:'CreateOrder/UpdateStandingOrder',
    POST_CUSTOMER_MANAGE_USER: 'User/Create',
    CREATE_EVENT: 'Event/CreateProject',
    POST_CREATE_INTERNAL_USER: 'User/CreateInternalUser',
    CREATE_PATIENT: 'Patient/CreatePatient',
    CREATE_QUESTION: 'Question/CreateQuestion',
    createSpecimen: 'Specimen/CreateSpecimen',
    createTest: 'Test/CreateTest',
    dashboardWidgetNotification: 'DashboardWidget',
    downloadCommercialOrders: 'CommercialOrder/Download/CommercialOrders',
    downloadOrderResults: 'OrderResult/Download/OrderResults',
    DownloadPatientList: 'Patient/Download/Patients',
    DownloadPurchaseOrders: 'CommercialOrder/Download/PurchaseOrders',
    downloadTestInstruction: 'Test/DownloadTestInstruction',
    editPatient: 'Patient/EditPatient',
    EDIT_QUESTION: 'Question/EditQuestion',
    editSpecimen: 'Specimen/EditSpecimen',
    editTest: 'Test/EditTest',
    emailFaxShare: 'Account/GetEmailFaxDto',
    exportCommercialOrders: 'CommercialOrder/ExportCommercialOrders',
    exportInternalUser: 'User/ExportInternalUsers',
    exportOrderResults: 'OrderResult/ExportOrderResults',
    ExportPatientList: 'Patient/ExportPatientList',
    ExportPurchaseOrders: 'CommercialOrder/ExportPurchaseOrders',
    EXPORT_QUESTIONS_SERVICE: 'Question/ExportQuestions',
    exportTestsData: 'Test/ExportTests',
    FORGOT_PASSWORD: 'LabPortAuth/ForgotPassword',
    VERIFY_MFA_CODE: 'LabPortAuth/VerifyMfaCode',
    GenerateNewReport: 'Report/GenerateNewReport',
    getActiveEventsByAccount: 'Event/GetActiveEventsByAccount/',
    GetBulkOrderAuditLog: 'BulkUpload/GetBulkOrderAuditLog/',
    GetActiveProjects: 'Event/GetActiveEventsByLinkedAccounts',
    getAllPatientsByAccount: 'Patient/GetAllPatientsByAccount/',
    GET_ANNOUNCEMENTS: 'Announcement/GetAnnouncements',
    GET_PRINTEDLABELS: 'PrintedLabels/GetPrintedLabels',
    SAVE_PRINTEDLABELS: 'PrintedLabels/SavePrintedLabels',
    EDIT_PRINTEDLABELS: 'PrintedLabels/EditPrintedLabels',
    PRINTEDLABELS_VALIDATERANGE: 'PrintedLabels/RangeValidate',
    PRINTEDLABELS_DELETERANGE: 'PrintedLabels/DeleteRange',
    GET_PRINTEDLABELACCOUNTCODES: 'PrintedLabels/GetPrintedLabelsAccounts',
    GET_ANNOUNCEMENTS_BY_ID: 'Announcement/GetAnnouncementById/',
    getAnnouncementsPostLogon: 'Announcement/GetAnnouncementsAfterLogon/',
    getAnnouncementsPreLogon: 'Announcement/GetAnnouncementsForLogonPage',
    GET_BU_BY_TEST_ID: 'Test/GetBUByTestId/',
    getBuCodeByAccountCode: 'Account/GetBuCodeByAccountCode/',
    getBulabSiteDetails: 'Account/GetBuLabSiteDetailsByAccountCode/',
    getBulkPatientDetails: 'Patient/GetPatientsByNames',
    GET_BUSINESS_UNITS_BY_ID: 'User/GetBusinessUnitsByUserId',
    getCommercialOrders: 'CommercialOrder/GetCommercialOrders',
    getComputationFormula: 'Demographic/GetComputationData',
    getCustomManageUser: 'User/CustomerUsers',
    getPhysiciansForGivenNPINumbers: 'Physician/GetPhysiciansForGivenNPINumbers',
    getReferencePhysiciansForGivenNPINumbers: 'Physician/GetReferencePhysiciansForGivenNPINumbers',
    GET_DASHBOARD_WIDGETS: 'Dashboard/GetDashboardWidgets',
    getDemographicData: 'Demographic/GetDemographicData',
    getDetailedResults: 'Result/GetDetailedResults',
    GET_DISPLAY_OPTIONS: 'Announcement/GetDisplayOptions',
    getEventByCodeAndPatientId: 'Event/GetEventByCodeAndPatientId/',
    getEventCodeByAccessCode: 'Event/GetEventCodeByAccessCode',
    getEventDetailsById: 'Event/GetEventDetailsByEventId',
    GET_EVENT_ENUM: 'EnumEvent/',
    getEvents: 'Event/GetEvents',
    GetEventsByLoggedinUserInfo: 'Event/GetEventsByLoggedinUserInfo',
    getICDCodeList: 'Patient/GetICDCodeList',
    getInsuranceDetailsByPatientId: 'InsurancePayor/GetInsuranceDetailsByPatientGuid',
    getDefaultICDCodeList: 'Patient/GetDefaultICD10CodeList',
    getInsuranceDetails: 'Patient/GetInsuranceDetailsByPatientGuid',
    getInternalUsers: 'User/InternalUsers',
    getkitIdFormat: 'CommercialOrder/GetKitIdFormat',
    getLAPreferenceAndSalesBU: 'Account/GetLinkedAccountPreference/',
    GET_LATEST_VERSION: 'Question/GetLatestQuestionVersion/',
    GET_LINKEDACCOUNTS_BY_BU: 'Account/GetLinkedAccountsByBU/',
    getLinkedAccountsByBUCode: 'OrderResult/GetLinkedAccountsByBU/',
    getLinkedAccountsAsPerBUCode: 'Account/GetLinkedAccountsAsPerBU/',
    GET_LINKED_ACCOUNTS_BY_ID: 'User/GetLinkedAccountsByUId',
    GET_MAIN_ACCOUNT_DTO: 'Order/GetMainAccounDtos',
    GET_PRINT_LABELS: 'PackageOrder/PrintOrderSpecimens',
    GET_ORDER_BY_REQUISITION_NUMBER: 'EasyOrder/GetOrderByRequisitionNumber/',
    getOrderConfirmationDetails: 'CommercialOrder/OrderConfirmationDetails',
    getOrderDetailByKitId: 'EasyOrder/GetOrderDetailByKitId/',
    GET_ORDER_ENUM: 'EnumOrder/',
    getOrderingPhysiciansForLA: 'Physician/GetPhysiciansBelongToLA/',
    getOrderTestUIControls: 'Order/GetTestUIControl',
    GetParentQuestionList: 'Question/GetParentQuestionList/',
    getPatient: 'Patient/GetPatient/',
    getEventByPatientId: 'Event/GetEventByPatientId/',
    assignUnAssignPatientToEvent: 'Event/AssignUnAssignPatientToEvent/',
    getPatientAOEs: 'Patient/GetPatientAOEs',
    getPatientByEmail: 'Patient/GetPatientListByEmail',
    GET_PATIENT_BY_NAME: 'Patient/GetPatientsByName',
    getPatientDetails: 'Patient/GetPatientDetails',
    getPatientList: 'Patient/GetPatientsByNames',
    GetPatientsByEvent: 'Event/GetPatientIdsByEvent/',
    GetPatientsByInputDetails: 'Patient/GetPatientsByInputDetails',
    GetDoctorsDayInfo: 'PackageOrder/GetDoctorsDayDetails',
    getPatientsByPatientId: 'Patient/GetPatientsByPatientId',
    getPayorList: 'InsurancePayor/GetInsurancePayors',
    getPayorListByInputDetails: 'InsurancePayor/GetInsurancePayorsByInputDetails',
    getPhysicianOrder: 'Physician/GetPhysicians',
    getProjectNames: 'Event/GetProjectIdByName',
    GetPurchaseOrders: 'CommercialOrder/GetPurchaseOrders',
    GetQuestionList: 'Question/GetQuestionList/',
    GetQuestionNameList: 'Question/GetQuestionNameList/',
    GET_QUESTIONS: 'Question/Questions',
    GetQuestionsByBUCode: 'Test/GetQuestionsByBUCode/',
    getQuestionsByTestCode: 'AoeRegistration/GetQuestionsByTestCodes',
    getQuestionsByTestId: 'Test/GetQuestionsByTestId/',
    getQuestionsForBU: 'Test/GetQuestionsByAccountCode/',
    getReferringPhysicianOrder: 'Physician/GetPhysiciansPerBU',
    GetReportData: 'Report/GetReports',
    getRequisitionSearchList: 'CommercialOrder/GetRequisitionNumbersSearch',
    cancelTgiOrder: 'CommercialOrder/CancelTgiOrder',
    getResults: 'OrderResult/GetOrderResults',
    getTestDetailsForGraph: 'OrderResult/GetTestDetailsForGraph',
    GetSlotsBookedByEventIdAndPatientId: 'EventScheduler/GetSlotsBookedByEventIdAndPatientId/',
    getSonographerList: 'Demographic/GetSonographerList/',
    getSpecimen: 'Specimen/GetSpecimen/',
    GET_SPECIMEN_DETAIL: 'Specimen/GetSpecimenDetail',
    GET_STATE_LIST: 'Patient/GetStateList',
    getSubContractBUDetailsByBU: 'Test/GetSubContractBUDetailsByBU/',
    getTestByTestId: 'Test/GetTestByTestId/',
    getTestCodeVersion: 'Test/LatestTestCodeVersion/',
    getTestDetails: 'Test/GetTestDetails',
    GET_TEST_ENUM: 'EnumTest/',
    getTestKitSuppliers: 'Test/GetTestKitSuppliers',
    getTests: 'Test/GetTests',
    getTestsByBu: 'Test/GetTestsByBu/',
    GetTestSearchByName: 'Test/GetTestSearchByName',
    getTestSelection: 'TestSelection/GetTestSelectionResults',
    getTestSelectionPaginated: 'TestSelection/GetTestSelectionResultsPaginated',
    getChildTestDetails: 'TestSelection/GetChildTestDetails',
    getTestDetailsForGivenTestCodes: 'TestSelection/GetTestDetailsForGivenTestCodes',
    getTestsSpecimenForLA: 'Test/GetTestsSpecimensByAccountCode/',
    getTestUIControls: 'Demographic/GetTestUIControl',
    getUiAuthorizeUrl: 'Authorization',
    GET_USER_DETAILS: 'User/GetLoggedInUserDetail',
    GET_USER_ENUM: 'EnumUser/',
    GET_USER_LINKED_ACCOUNTS: 'User/GetUserLinkedAccounts/',
    getPayors: 'Payor/GetPayors',
    getPayorById: 'Payor/GetPayor/',
    getPayorsByName: 'Payor/GetPayorsByName',
    createPayor: 'Payor/CreatePayor',
    editPayor: 'Payor/EditPayor',
    checkUniquePayorID: 'Payor/CheckUniquePayorID/',
    internalUserDetailsWithPermission: 'User/GetInternalUserWithPermission',
    isPatientExist: 'Patient/IsPatientExist',
    isSpecimenAssociated: 'Specimen/IsSpecimenAssociated',
    IS_SPECIMEN_EXIST: 'Specimen/IsSpecimenExist',
    loggedInUserInfo: 'loggedInUserInfo',
    loggedUserPermissions: 'User/Create/Permissions/',
    login: 'LabPortAuth/Login',
    logout: 'LabPortAuth/Logout',
    policyAcceptanceDetail: 'Content/GetPolicyAcceptanceDetail',
    privacyPolicy: 'Content/LabPort/PrivacyPolicy',
    orderingPhysicianContent: 'Content/LabPort/OrderingPhysicianSignature',
    REFRESH_TOKEN: 'LabPortAuth/RefreshToken',
    reportDownload: 'Report/DownloadReport',
    DownloadReportAndUpdateIsRead: 'Report/DownloadReportAndUpdateIsRead',
    reportSend: 'Report/SendReport',
    reportSendFax: 'Report/SendReportFax',
    SEND_OTP: 'LabPortAuth/SendOtp',
    setPassword: 'LabPortAuth/SetPassword',
    SET_USER_PREFERENCE: 'User/SetUserPreference',
    SIGNALR_NOTIFICATION: 'SignalRNotificationHub',
    specimenKitId: 'CommercialOrder/EditSpecimenKitId',
    termsOfUse: 'Content/LabPort/TermsOfUse',
    buNavigationLink: 'Content/LabPort/ExternalLink',
    eurofinsSupport: 'Content/LabPort/EurofinsSupport',
    eurofinsSupportForBulkExport: 'Content/LabPort/EurofinsSupportForBulkExport',
    UPDATE_ANNOUNCEMENT: 'Announcement/UpdateAnnouncement',
    updateCustomerUser: 'User/Update',
    updateDemographic: 'Demographic/UpdateDemographicData',
    updateEasyOrderResult: 'EasyOrder/UpdateEasyOrderResult',
    UpdateEventDetails: 'Event/UpdateEventDetails/',
    updateInternalUser: 'User/UpdateInternalUser',
    updatePatientDetail: 'Patient/UpdatePatientDetail',
    updatePolicyDetail: 'Content/UpdatePolicyDetail',
    updateUser: 'User/Update/Profile',
    updateUserAnnouncements: 'Announcement/UpdateUserAnnouncements',
    user: 'User/',
    userDetailsWithPermission: 'User/UserDetails/',
    getAccountGridDetails: 'Account/GetAccounts',
    accountNameSearch: 'Account/GetAccountsByNames',
    checkIfBuAccountCodeExists: 'Account/IsAccountCodeExists',
    getPhysiciansAssociatedToBu: 'Physician/GetPhysicianAssociatedAToBu/',
    createAccount: 'Account/CreateAccount',
    getAccountById: 'Account/GetAccountById/',
    editAccountDetails: 'Account/EditAccount/',
    validateTestParameters: 'Test/ValidateParameters',
    GetParametersByTestId: 'Test/GetParametersByTestId/',
    downloadParameterUploadTemplate: 'Test/DownloadParameterUploadTemplate',
    physicianDetailsFromRegistry: 'Physician/GetPhysicianDetailsFromRegistry',
    mergeMultipleReportsAndDownload: 'Report/MergeMultipleReportsAndDownload',
    GET_DASHBOARD_RESULTS: 'Dashboard/GetDashboardResults',
    getIfAllReportsExists: 'Report/IfAllFileExists',
    GET_BUSINESSUNIT_DETAILS_FOR_RESULTS: 'BusinessUnit/GetBusinessUnitDetailsForResults',
    GetAzureKeys: 'Azure/AzureKeys',
    GetAccountDetailsForPackageCreation: 'AccountPreference/GetAccountDetailsForPackageCreation/',
    GetAccountPrefDetailsForOrderForm: 'AccountPreference/GetAccountPreferenceDetails',
    GetPackageGridDtos: 'Package/GetPackageGridDtos',
    GetPackageGridOrders: 'Package/GetPackageGridOrders/',
    CreateLabOrder: 'PackageOrder/CreatePackageOrder',
    CancelPackage: 'PackageOrder/CancelPackage',
    CancelOrder: 'PackageOrder/CancelOrder',
    RequistionManifestDetails : 'PackageOrder/GetRequisitionManifestDetails/',
    SendPackage: 'PackageOrder/SendPackage',
    getShipperTypesByPackageAccount: 'AccountPreference/GetShipperTypeAndReceivingLabsForPackageAccount/',
    getPackageManifestDetails: 'PackageOrder/GetPackageManifestDetails/',
    getReceivingLabsByLoggedInCustomerUser: 'Account/GetReceivingLabsByLoggedInCustomerUser/',
    getReceivingLabsByLoggedInInternalUser: 'Account/GetReceivingLabsByLoggedInInternalUser/',
    getSpecimensForRequisitionNumber: 'CommercialOrder/GetSpecimens',
    getPackageIdOrRequisitionNumberSearch: 'Package/GetPackageAndRequisitionById',
    packageManifestExport: 'PackageOrder/ExportPackageManifest/',
    requisitionManifestExport: 'PackageOrder/ExportRequisitionManifest/',
    getOrderStatusTrackers: 'OrderStatusTracker/GetOrderStatusTrackers',
    getClientId1SearchResults: 'OrderResult/GetClientID1SearchResults',
    getRequisitionSearchResults: 'OrderStatusTracker/GetRequisitionSearchResults',
    checkIfReqNoBelongsToLabelRangeByAccCode: 'AccountPrePrintedLabel/CheckIfRequisitionBelongsToLabelRangeByAccCode/',
    getPackageDetailsByLabportpackageCode: 'Package/GetpackageDetailsByLabportPackageCode/',
    isPackageInCurrentStatus: 'Package/IsPackageInCurrentStatus/',
    getBulkUploadOrderInstructions: 'Package/GetBulkUploadOrderInstructions/',
    validateBulkOrderUpload: 'BulkUpload/ValidateAndUploadBulkOrders',
    confirmBulkOrderUpload: 'PackageOrder/ConfirmUpload',
    DOWNLOAD_BULKORDERTEMPLATE: 'BulkUpload/DownloadBulkUploadOrderTemplate',
    printAllOrderSpecimens: 'PackageOrder/PrintAllOrderSpecimens/',
    canAccountPlaceUserPrintedLabelOrder: 'AccountPrePrintedLabel/CanAccountPlaceUserPrintedLabelOrder',
    GetUserInfo: 'UserInfoCache/GetUserInfo/',
    GetLAWithAddressByAccountCode: 'UserInfoCache/GetLAWithAddressByAccountCode/',
    GetLinkedAccountWithAuthByAccountCode: 'UserInfoCache/GetLinkedAccountWithAuthByAccountCode/',
    HasLinkedAccount: 'UserInfoCache/HasLinkedAccount',
    SendLoginMfaOTP:'LabPortAuth/SendLoginMfaOtp',
    CheckAnyUserExistsOnPortalByEmail: 'User/CheckAnyUserExistsOnPortalByEmail/',
    GetLmnReasonsList:'CommercialOrder/GetLmnReasonList',
    ExportLmnAsPdf: 'CommercialOrder/ExportLmnAsPdf',
    UpdateOrderRequest: 'CommercialOrder/RequestOrderUpdate',
    GetUserActivityLogs: 'EventUserActivity/GetAuditLogs'
};
